import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from '@chakra-ui/react'
import styles from "./style.module.css"
import crossImg from "../../../assets/crossImg.svg"

// import { useDispatch } from 'react-redux'
// import { fetchCurrentSubscriptionData, updateCurrentSubscriptionData } from '../../Redux/Subscription/CurrentSubscriptionReducer'
import { RiDeleteBin6Fill } from 'react-icons/ri'
// import { message } from 'antd'

const DeleteModel = ({ el, type }) => {
  // const dispatch = useDispatch()
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <p onClick={onOpen} className={styles.blackBtn31}>Cancel</p>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
          </ModalBody>
          <div className={styles.deleteModeldiv}>
            <img src={crossImg} alt="" />

            <p>Are your sure want to delete this<br />
              Advertisement plan?</p>
          </div>

          <ModalFooter>
            <div className={styles.modelFooter}>
              <Button variant='solid' color="black" mr={3}
              //  onClick={() => dispatch(updateCurrentSubscriptionData({ deleted: true, SubscriptionId: el._id })).then(() => {
              //   dispatch(fetchCurrentSubscriptionData(type)).then(() => {
              //     onClose()
              //     message.error("Subscription had been deleted")
              //   })

              // })}
              >
                Yes
              </Button>
              <Button variant='outline' color="black" onClick={onClose}>No</Button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>

  )
}

export default DeleteModel